import moment from "moment";
import { LeasmanContractService } from "../../../system/Domain";
import ListItemChip from "../../../Components/ListItemChip";
import dateFormats from "../../../system/dateFormats";

interface Props {
	leasmanContractServices: LeasmanContractService[]
	contractEndDate?: string | null
}

export const isServiceValid = (service: LeasmanContractService, contractEndDate: string | null | undefined): boolean => {
	if (!service.validTo) return true;
	if (!contractEndDate) return false;
	return moment(contractEndDate).add(-1, "month").isBefore(moment(service.validTo));
};

const ServiceChips = (props: Props) => {
	if (!props.leasmanContractServices || props.leasmanContractServices?.length === 0) {
		return <ListItemChip label="Keine Services" />;
	}

	return (
		<>
			{props.leasmanContractServices.map(bc => {
				const valid = isServiceValid(bc, props.contractEndDate);
				const tooltip = bc.validTo
					? valid
						? `Gültig bis ${moment(bc.validTo).format(dateFormats.date)}`
						: `Service abgelaufen am ${moment(bc.validTo).format(dateFormats.date)}`
					: undefined;
				return (
					<ListItemChip
						color={valid ? "secondary" : "error"}
						key={bc.type.id}
						label={bc.type.name}
						tooltip={tooltip}
					/>
				);
			})}
		</>
	);
};

export default ServiceChips;
